import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NimbusTooltipComponent } from './components/nimbus-tooltip/nimbus-tooltip.component';

@NgModule({
  imports: [MatTooltipModule],
  declarations: [NimbusTooltipComponent],
  exports: [NimbusTooltipComponent],
})
export class NimbusTooltipModule {}
